// Remove Dep on lodash groupBy
// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_groupby
export const groupBy = function (array, key) {
  return array.reduce(function (grouping, obj) {
    grouping[obj[key]] = grouping[obj[key]] || []
    grouping[obj[key]].push(obj)
    return grouping
  }, {})
}
